import { useEffect, useState } from "react";
import { profile } from "../../data/resume";
import { scrollToId, scrollToTop } from "../../hooks/useLenis";

const links = [
  { label: "About", id: "about" },
  { label: "Experience", id: "experience" },
  { label: "Leadership", id: "leadership" },
  { label: "Skills", id: "skills" },
  { label: "Contact", id: "contact" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => scrollToId(id);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        scrolled
          ? "bg-paper/85 backdrop-blur-md border-b border-hair py-3"
          : "bg-transparent border-b border-transparent py-5"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 sm:px-12 lg:px-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={scrollToTop}
          className="font-mono text-xs uppercase tracking-[0.28em] text-ink hover:text-rust transition-colors duration-300"
        >
          Gauri Ambekar
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}-link`}
              onClick={() => go(l.id)}
              className="font-sans text-sm text-inksoft hover:text-ink transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <a
          data-testid="nav-email-cta"
          href={`mailto:${profile.email}`}
          className="hidden sm:inline-flex items-center gap-2 rounded-full border border-ink px-5 py-2 text-sm text-ink hover:bg-ink hover:text-paper transition-colors duration-300"
        >
          <span className="h-1.5 w-1.5 rounded-full bg-rust" />
          Get in touch
        </a>
      </div>
    </header>
  );
};
